import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import config from "./config/index";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

firebase.initializeApp(config.firebaseConfig);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
